import { create } from 'zustand'

import { toast } from '@/shared/lib/toast'

import * as marketingApi from '../api/marketing.api'

const initialState = {
  marketing: [],
  meta: null,
  isLoading: true,
  error: null,
}

export const useMarketingStore = create((set, get) => ({
  ...initialState,

  clearError: () =>
    set({
      error: null,
    }),

  fetchMarketing: async (params = {}) => {
    set((state) => ({
      isLoading: state.marketing.length === 0,
      error: null,
    }))

    try {
      const result = await marketingApi.getMarketing(params)

      set({
        marketing: result.data,
        meta: result.meta,
        isLoading: false,
        error: null,
      })

      return result
    } catch (error) {
      const message = error.message || 'Failed to fetch marketing'

      set({
        isLoading: false,
        error: message,
      })

      toast.error(message)
      throw error
    }
  },

  createMarketingPerson: async (payload) => {
    if (get().isLoading) return null

    set({
      isLoading: true,
      error: null,
    })

    try {
      const result = await marketingApi.createMarketing(payload)

      toast.success(result.message || 'Marketing person created successfully')

      const marketingResult = await marketingApi.getMarketing({
        page: 1,
        limit: 10,
      })

      set({
        marketing: marketingResult.data,
        meta: marketingResult.meta,
        isLoading: false,
        error: null,
      })

      return result
    } catch (error) {
      const message = error.message || 'Failed to create marketing person'

      set({
        isLoading: false,
        error: message,
      })

      toast.error(message)
      throw error
    }
  },

  updateMarketingPerson: async (id, payload) => {
    set({
      isLoading: true,
      error: null,
    })

    try {
      const result = await marketingApi.updateMarketing(id, payload)

      toast.success(result.message || 'Marketing person updated successfully')

      set((state) => ({
        marketing: state.marketing.map((item) =>
          item._id === id ? result.data : item,
        ),
        isLoading: false,
        error: null,
      }))

      return result
    } catch (error) {
      const message = error.message || 'Failed to update marketing person'

      set({
        isLoading: false,
        error: message,
      })

      toast.error(message)
      throw error
    }
  },

  deleteMarketingPerson: async (id) => {
    set({
      isLoading: true,
      error: null,
    })

    try {
      const result = await marketingApi.deleteMarketing(id)

      toast.success(result.message || 'Marketing person deleted successfully')

      set((state) => ({
        marketing: state.marketing.filter((item) => item._id !== id),
        isLoading: false,
        error: null,
      }))

      return result
    } catch (error) {
      const message = error.message || 'Failed to delete marketing person'

      set({
        isLoading: false,
        error: message,
      })

      toast.error(message)
      throw error
    }
  },
}))
